import React, { FC } from 'react'
import styled from 'styled-components'

import SignOutButton from '../components/buttons/signoutButton'

const Wrapper = styled.div`
  height: 100%;
  padding: 0px 20px 0px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const TopBar: FC<any> = ({
  hidden = false
}: {
  hidden?: boolean
  [key: string]: any
}) => {
  return <Wrapper>{!hidden && <SignOutButton />}</Wrapper>
}

export default TopBar
